module.exports = __webpack_public_path__ + "static/media/girl-26.2e992b11.svg";